import React, { useState, useEffect } from 'react';
import { motion } from "framer-motion";

const Organogram = () => {
  const [pdfFiles, setPdfFiles] = useState([
    {
      id: "main",
      title: "Main Organogram",
      path: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS%20Organogram%20-%20Organogram%20(3).pdf?alt=media&token=55826ead-e4fe-4de2-a966-adc9f25bfaae"
    },
    {
      id: "nigerian",
      title: "Nigerian Nation",
      path: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS%20Organogram%20-%20Nigerian%20Nation%20(2).pdf?alt=media&token=1b459603-f548-408a-bb3f-57a5c61a9474"
    },
    {
      id: "other",
      title: "Other Nations",
      path: "https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS%20Organogram%20-%20Other%20Nations%20(2).pdf?alt=media&token=12272e6a-4bfe-4fb6-bb40-d3db6435a7e7"
    }
  ]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      // Simply check if PDF files are loaded
      if (pdfFiles.length > 0) {
        setLoading(false);
      }
    } catch (err) {
      console.error("Error loading PDF files:", err);
      setError("Could not load the organogram files. Please ensure PDF files are available.");
      setLoading(false);
    }
  }, []);

  const openPdfInBrowser = (pdfUrl) => {
    window.open(pdfUrl, '_blank');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-lg font-medium text-gray-700">Loading BCS Organogram files...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 p-4 rounded-lg">
        <h2 className="text-red-800 text-lg font-medium mb-2">Error</h2>
        <p className="text-red-700">{error}</p>
        <p className="mt-2 text-red-700">Please make sure you have uploaded the organogram PDF files.</p>
      </div>
    );
  }

  return (
    <motion.div
      className="pt-2 md:px-6 lg:px-20 max-w-6xl mx-auto"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1.5,
        delay: 0.2,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <div className="bg-white mt-5 mx-5 rounded-xl shadow-lg overflow-hidden">
        <div className="p-4 bg-gradient-to-r from-blue-700 to-blue-500 text-white">
          <h1 className="text-xl md:text-2xl font-bold">BCS Organogram</h1>
        </div>
      
        <div className="p-6">
          {/* <h2 className="text-lg font-medium text-gray-700 mb-3">Select a document to open in your browser</h2> */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {pdfFiles.map((pdf, index) => (
              <motion.button
                key={index}
                onClick={() => openPdfInBrowser(pdf.path)}
                className="p-5 bg-blue-50 hover:bg-blue-100 text-blue-800 rounded-lg shadow-sm transition-all text-left"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <div className="flex items-center">
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="h-8 w-8 mr-3 text-blue-600" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={1.5} 
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" 
                    />
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={1.5} 
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" 
                    />
                  </svg>
                  <div>
                    <h3 className="font-medium text-lg">{pdf.title}</h3>
                    <p className="text-sm text-blue-700 mt-1">Click to view in new tab</p>
                  </div>
                </div>
              </motion.button>
            ))}
          </div>
        </div>

        <div className="bg-gray-50 p-4 border-t border-gray-200">
          <p className="text-gray-600 text-sm">BCS Organogram • {new Date().toLocaleDateString()}</p>
        </div>
      </div>
    </motion.div>
  );
};

export default Organogram;